<template>
  <div id="tabsComponent" class="asset-page">
    <div class="container">
      <div class="row tabs-wrapper">
        <button
          v-for="(tab, index) in tabs"
          v-bind:key="tab"
          v-bind:class="[
            'tab-button',
            tab,
            { active: currentTab === tab, animated: index === 0 }
          ]"
          v-on:click="tabSwitch(tab)"
        >
          {{ componentToDictName(tab) }}
        </button>
      </div>
    </div>
    <div class="tab-wrapper" :class="[currentTab,{active: loggedAndActive}]">
      <keep-alive>
        <component
          v-bind:is="currentTab"
          :symbol="symbol"
          class="tab"
        ></component>
      </keep-alive>
      <div class="risk" v-if="regulation === 'vpr'">
        {{t("risk_asset")}}
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "@/components/Chart";
import Overview from "@/components/InstrumentOverview";
import Signals from "@/views/plus/Signals";
import News from "@/views/plus/itemList/News";
import Webinars from "@/views/plus/itemList/Webinars";
import Ebooks from "@/views/plus/itemList/Ebooks";

import {mapGetters, mapState} from "vuex";

export default {
  name: "tabs",
  props: ["symbol"],
  components: { Chart, Overview, Signals, News, Webinars, Ebooks },
  data() {
    return {
      currentTab: "Chart",
      tabs: ["Chart", "Overview", "signals", "News", "Webinars", "Ebooks"],
      visitedTabs: []
    };
  },
  created() {
    this.visitedTabs.push(this.currentTab);
  },

  computed: {
    ...mapState(["regulation"]),
    ...mapGetters(["t","loggedAndActive"])
  },
  methods: {
    tabSwitch: function(tab) {
      if (this.currentTab != tab) {
        this.animateTabSwitch(this.currentTab, tab);
        if (!this.visitedTabs.includes(tab)) {
          this.visitedTabs.push(tab);
        }
        this.currentTab = tab;
        this.scrollDisplayToTab(tab);
      }
    },
    scrollDisplayToTab: function() {
      const tabsWrapper = document.querySelector(".tabs-wrapper");
      const currentTabLeftDistance = tabsWrapper.querySelector(
        ".tab-button." + this.currentTab
      ).offsetLeft; //used "currentTab" var instead of "active" class, because dom might not be updated with the class yet when this code runs
      tabsWrapper.scrollLeft = currentTabLeftDistance;
    },
    animateTabSwitch(current, next) {
      let sibilingSelector;
      if (this.tabs.indexOf(current) > this.tabs.indexOf(next)) {
        sibilingSelector = "previousElementSibling";
      } else {
        sibilingSelector = "nextElementSibling";
      }
      let currentTab = document.querySelector(".tab-button." + current);
      let animateInterval = setInterval(function() {
        if (!currentTab.classList.contains(next)) {
          currentTab.classList.remove("animated");
          currentTab = currentTab[sibilingSelector];
          currentTab.classList.add("animated");
        } else {
          clearInterval(animateInterval);
        }
      }, 60);
    },
    componentToDictName: function(component) {
      let dictKey;
      switch (component) {
        case "Chart":
          dictKey = "chart";
          break;
        case "Overview":
          dictKey = "overview_label";
          break;
        case "signals":
          dictKey = "Trading_Signals";
          break;
        case "News":
          dictKey = "News_label";
          break;
        case "Webinars":
          dictKey = "Header_Nav_Webinars";
          break;
        case "Ebooks":
          dictKey = "ebook_title";
          break;
        default:
          dictKey = "";
      }
      return this.t(dictKey);
    }
  }
};
</script>

<style lang="scss" scoped>
#tabsComponent {
  .tabs-wrapper {
    display: flex;  margin-top: 0.875rem;

    flex-wrap: nowrap;
    overflow-x: auto;
    width: auto;
    &::-webkit-scrollbar {
      height: 0px;
    }
  }
  .tab-button {
    padding: 0px 24px 1rem;
    background: none;
    color: #9e9e9e;
    font-size: 1rem;
    border: none;
    border-bottom: 3px solid transparent;
    white-space: nowrap;
    -webkit-tap-highlight-color: rgba(
      0,
      0,
      0,
      0
    ); //remove blue background on tab change
    @media only screen and (max-width: 768px) {
      padding: 0 1rem 1rem;
      font-size: 0.875rem;
    }
  }

  .tab-button {
    &.active {
      font-weight: bold;
      color: #424242;
      border: none;
    }
    &.animated {
      border-bottom: 3px solid #1c79be;
    }
  }
  .tab-button:focus {
    outline: none;
  }

  .tab-wrapper {
    background-color: #f5f5f5;
  }

  $desktop-padding-vertical: 40px;
  $mobile-padding-vertical: 16px;

  ::v-deep {
    //css for inner components
    .tab-wrapper > *:not(.risk),
    .tab-wrapper #signals {
      //private case of #signals mentioned in order to increase the selector priority
      @media only screen and (min-width: 768px) {
        padding: $desktop-padding-vertical 0 0;
      }
      &:not(#chartComponent) {
        @media only screen and (max-width: 768px) {
          padding: $mobile-padding-vertical 0 0 !important; //important is required to override the css code used in itemsList.vue who also uses important tag (see also usage explenation there)
        }
      }
    }
    .tab-wrapper.Chart > .risk, .tab-wrapper.Overview > .risk,  { //fix distance to risk text
      padding-top: 1rem;
    }
    .tab-wrapper .assets_section{padding-bottom: 40px;}
    @media only screen and (min-width: 768px) { //fix distance to risk text
      .tab-wrapper.signals:not(.active) > .risk{
        padding-top: 1rem;
      }
    }

    .tab-wrapper.signals:not(.active) > * .form_wrap{ //fix distance to risk text
      margin-bottom: 0;
    }

    .available-soon {
      @media only screen and (min-width: 768px) {
        height: calc(434px - #{$desktop-padding-vertical * 2});
      }
      @media only screen and (max-width: 768px) {
        height: calc(390px - #{$mobile-padding-vertical * 2});
      }
    }

    .current_page {
      //list items page title hide.
      .itemListTitle {
        display: none;
      }
    }
    #signals {
      //signals title and banner hide. (required more prioratize selector)
      .background-wrapper,
      .header-container {
        display: none;
      }
    }

    #signals {
      &:not(.activeUser) {
        .available-soon {
          //if user not logged in dont show the available soon - show registration form
          display: none;
        }
        @media only screen and (max-width: 768px) {
          //if mobile - show only registration form
          .cards-wrapper {
            //if desktop
            margin-bottom: 0px; //show registration form above the signals
          }
          .login-register-wrapper {
            position: relative;
            top: -$mobile-padding-vertical;
            width: 100%;
          }
        }
        @media only screen and (min-width: 768px) {
          .cards-wrapper {
            //if desktop
            margin-bottom: -164px; //show registration form above the signals
            &.empty {
              margin-bottom: 0px; //if no signals - remove then margin so the form will be located properly
            }
          }
        }
      }
    }
    .SignalsBox {
      .innerBox {
        background: #ffffff;
        border: 1px solid #d5d3d3;
        border-radius: 3px;
        padding-bottom: 1rem;
        .middleDetails,
        .btnWrap {
          //it would have been better to make another wrapper inside .innerBox but I dont want to modify the general signalcard structure
          padding-right: 1rem;
          padding-left: 1rem;
        }
        .symbol-top-container {
          display: none;
        }
      }
    }
    #webinarsBox,
    #newsBox,
    #ebooksBox {
      background-color: #ffffff;
    }
  }
}

.risk{
  text-align: center;
  font-size: 0.875rem;
  padding-bottom: 1rem;
  padding-right: 1rem;
  padding-left: 1rem;
}
</style>

<!--used for signals page background when user is not logged in. canceled due to conversation with Ron-->
<!--<style lang="scss">-->
<!--.alvexo_plus_wrapper:not(.active){-->
<!--  #tabsComponent{-->
<!--    .tab-wrapper.signals{-->
<!--      background: transparent linear-gradient(180deg, #FFFFFF47 0%, #FFFFFF9D 26%, #FFFFFFE0 36%, #FFFFFF 65%, #FFFFFF 100%) 0% 0% no-repeat padding-box;-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</style>-->
